import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const USFlagIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 32 24" {...props}>
            <g clipPath="url(#clip0)">
                <g>
                    <path d="M0 0H32V24H0" fill="#BD3D44" />
                    <path
                        d="M0 2.76501H32H0ZM0 6.45001H32H0ZM0 10.15H32H0ZM0 13.85H32H0ZM0 17.55H32H0ZM0 21.25H32H0Z"
                        fill="black"
                    />
                    <path
                        d="M0 2.76501H32M0 6.45001H32M0 10.15H32M0 13.85H32M0 17.55H32M0 21.25H32"
                        stroke="white"
                        stroke-width="1.85"
                    />
                    <path d="M0 0H18.24V12.925H0" fill="#192F5D" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="32" height="24" fill="white" />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};
